import React from "react";
import { Autocomplete, SvgIcon, TextField } from "@mui/material";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import {
  capitalizeWords,
  finderTipoExamenByName,
} from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  isChangeFormSearchState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import { tipoExamenState } from "./state/atoms";
import SucursalIcon from "src/shared/icons/SucursalIcon";
import ModalidadIcon from "src/shared/icons/ModalidadIcon";

const AutocompleteTipoExamen = ({ size = "small", styles, myEvent }) => {
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const tipoExamenes = useRecoilValue(tipoExamenState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);

  const nuevoBuscador = window.location.pathname.indexOf("nuevo-buscar") >= 0;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-tipoexamen"
        text="Tipo de Examen"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-tipoexamen"
        options={tipoExamenes.map((option) => `${option.ptD_NOMBRE}`)}
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={filterSearchSelected.tipoExamenSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              tipoExamenSelected: {
                ...filterSearchSelected.tipoExamenSelected,
                value: "",
                code: null,
              },
              examenSelected: {
                ...filterSearchSelected.examenSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const findTipoExamen = finderTipoExamenByName(tipoExamenes, value);
            console.log("findTipoExamen => ", findTipoExamen);
            myEvent(findTipoExamen);
            setFilterSearchSelected({
              ...filterSearchSelected,
              tipoExamenSelected: {
                ...filterSearchSelected.tipoExamenSelected,
                value: value,
                code: findTipoExamen?.ptD_RUT,
              },
              examenSelected: {
                ...filterSearchSelected.examenSelected,
                value: "",
                code: null,
              },
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              ...styles.autocomplete,
              input: {
                ...styles.texfield,
              },
            }}
            placeholder={nuevoBuscador ? "Tipo de Examen" : "Buscar"}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: nuevoBuscador > 0 && (
                <>
                  <SvgIcon sx={{ fontSize: "15px" }}>
                    <ModalidadIcon />
                  </SvgIcon>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteTipoExamen;
